import React from "react";
import { Provider } from 'react-redux'
import cx from "classnames";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import { store } from 'store'

import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { enUS, ruRU, zhCN } from '@mui/x-date-pickers-pro/locales';
import { LicenseInfo } from '@mui/x-license-pro';

import AuthProvider from 'components/auth/auth-provider'
import {MUI_LICENSE_KEY, ROUTES} from 'config/constants'
import {getLanguageCode} from 'config/i18'
import { MUI_THEME } from '@vedmarket/ui-kit';
import ScrollToHashElement from './components/common/scrollToHashElement';

import Navigator from './components/routes/navigator';
import '@vedmarket/ui-kit/ui-kit.css';

import './app.scss'
import './styles/common.scss'

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const DATE_PICKER_LOCALIZATIONS = {
  en: {
    adapterLocale: 'en',
    localeText: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  },
  ru: {
    adapterLocale: 'ru',
    localeText: ruRU.components.MuiLocalizationProvider.defaultProps.localeText,
  },
  zh: {
    adapterLocale: 'zh-cn',
    localeText: zhCN.components.MuiLocalizationProvider.defaultProps.localeText,
  },
};

const App = () => {

  const { i18n } = useTranslation();

  const location = useLocation();
  const language = getLanguageCode(i18n.language);
  const datePickerLocalization = DATE_PICKER_LOCALIZATIONS[language];

  const isAuthPage =
      location.pathname.includes(ROUTES.LOGIN) ||
      location.pathname.includes(ROUTES.REGISTER) ||
      location.pathname.includes(ROUTES.FORGOT_PASSWORD) ||
      location.pathname.includes(ROUTES.RESET_PASSWORD);

  return (
    <ThemeProvider theme={MUI_THEME}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={datePickerLocalization.adapterLocale}
        localeText={datePickerLocalization.localeText}
      >
        <Provider store={store}>
          <AuthProvider>
            <div className={cx('app', {
              'app_isAuth': isAuthPage,
            })}>
              <ScrollToHashElement />
              <Navigator />
            </div>
          </AuthProvider>
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  )
}


export default App
